import axios from "axios";
import { baseUrl } from "../util";

// Flow 38 - Transportation to Use Stage
export const getAllTransportation38LCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/transportation-38-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching transportation 38:", error);
      setObjects([]);
    });
};

export const addTransportation38LCA = ({
  productId,
  means_of_transportation,
  city_of_departure,
  departure_country,
  city_of_destination,
  destination_country,
  transport_distance,
  fu_transported,
  packaging_included,
  manual_emission_factor,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/transportation-38-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      means_of_transportation: means_of_transportation,
      city_of_departure: city_of_departure || null,
      departure_country: departure_country || null,
      city_of_destination: city_of_destination || null,
      destination_country: destination_country || null,
      transport_distance: transport_distance || 0,
      fu_transported: fu_transported || 0,
      packaging_included: packaging_included || null,
      manual_emission_factor: manual_emission_factor || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding transportation 38:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add transportation",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateTransportation38LCA = ({
  productId,
  rowId,
  means_of_transportation,
  city_of_departure,
  departure_country,
  city_of_destination,
  destination_country,
  transport_distance,
  fu_transported,
  packaging_included,
  manual_emission_factor,
  objects,
  setObjects,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/transportation-38-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      means_of_transportation: means_of_transportation,
      city_of_departure: city_of_departure || null,
      departure_country: departure_country || null,
      city_of_destination: city_of_destination || null,
      destination_country: destination_country || null,
      transport_distance: transport_distance || 0,
      fu_transported: fu_transported || 0,
      packaging_included: packaging_included || null,
      manual_emission_factor: manual_emission_factor || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating transportation 38:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update transportation",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteTransportation38LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/transportation-38-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting transportation 38:", error);
    });
};

// Flow 38: Get Total Impact for Transportation to Use Stage
export const getTransportation38Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/transportation-38-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching transportation 38 totals:", error);
      setTotals(null);
    });
};

